import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../RenderStyle.css";

import EC_Render from "../../../../../UiComponents/EC_Render";
import Navbar from '../../../../../UiComponents/June2026/Navbar';
import RenderNavbar from '../../../../../UiComponents/June2026/RenderNavbar';
import RenderSettings from '../../RenderSettings';
import RendersTable from '../RendersTable';
import { Scrollx_animate } from "../../../../../assets/icons";

import { renderSettingsOptions, fpsNumAndDen, commonFps, format, getResolutionFromHeightAndWidth } from "../../render.constants";
import { setCurrentNotification } from "../../../../utils/global";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { increaseRenderCnt } from "../../../../../Redux/actions/authActions";
import { updatePreviewScale } from "../../../../../Redux/actions/applicationActions";
import { requestRenderXVideo, deleteRenders, deleteAllRenders, downloadRender, requestRenderX3Video } from "../../../../../Redux/actions/projectActions";
import ConfirmationModal from "../../../../../Components/ConfirmationModal/ConfirmationModal";
import { getCurrentPlan, getRendersPlan, getNotification, addNotifications, getUserAllInformation, markRenderDone } from "../../../../../Redux/actions/commonActtion";

import { toast } from "react-toastify";
import CustomToast, { customToatStyle } from "../../../../../Components/CustomToast/CustomToast";

import { captureElementAsPng } from "../../../../utils/generateCreditsPng";
import { getProjectBackgroundStyle } from "../../../utils/projectBackground";

const freeRenderFormats = Object.entries(format).map(([key, value]) => ({ label: key, value: value }));
const freeFramRate = commonFps.map((fps) => ({ label: fps, value: 23.976 }));
const defaultResolution = "1280 x 720";
const mesg = "Rendering in Progress Your render is currently being processed. You will receive a notification via email when its complete. Thank you for your patience!";

const CardRender = ({ renderOpen, setRenderOpen, currentBlockIdx, isRenderExport, setIsRenderExport }) => {
  console.log("1 CardRender Component Mounted Props => ", { renderOpen, setRenderOpen, currentBlockIdx, isRenderExport, setIsRenderExport });
  const user = JSON.parse(localStorage.getItem("user"));
  const { projectId } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [aspectRatio, setAspectRatio] = useState("1.78");
  const [isEmailSend, setIsEmailSend] = useState(true);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  // segregate the card specific options
  const [cardScreenOptions, setCardScreenOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpgradeOpen, IsUpgradeOpen] = useState(false);
  const [isPlanShow, setIsPlanShow] = useState(false);
  
  let { isLoading, renders, settings: projectSettings } = useSelector((state) => state?.project);
  const { _id, isCard } = useSelector((state) => state?.project);
  const { videoWidth, videoHeight } = useSelector((state) => state?.project?.resolution,);
  console.log("CardRender Redux project Data = ", { _id, isCard, videoWidth, videoHeight });
  const { credits } = useSelector((state) => state?.project);
  const { renderPlan, subscriptionStatus } = useSelector((state) => state.commonReducer);
  const commonReducer = useSelector((state) => state?.commonReducer);
  const { renderCnt } = useSelector((state) => state.userInfo);

  const { userData, renderDone, currentPlan } = useSelector((state) => state?.commonReducer);

  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(currentPlan.isExpired ? false : true);

  useEffect(() => {
    setIsUserPaid(currentPlan.isExpired ? false : true);
  }, [currentPlan.isExpired]);

  // if user is paid, we are getting the settings from local storage, if user is not paid, we are removing the settings from local storage
  let renderSettingData = null;
  if (isUserPaid) {
    renderSettingData = JSON.parse(localStorage.getItem("renderSettings"));
  } else if (!isUserPaid) {
    if (renderSettingData) {
      localStorage.removeItem("renderSettings");
    }
  }
  // const renderSettingFormat = renderSettingData !== null ? renderSettingData.format !== "H264" ? renderSettingData.format.substring(6) : "H264" : "";
  const renderSettingFormat =
    renderSettingData !== null ? renderSettingData.format : "";

  // Getting default settings from local storage, if renderSettings is available otherwise we are taking default setting
  const [resolution, setResolution] = useState(
    renderSettingData !== null ? renderSettingData.resolution : defaultResolution,
  );
  const [formats, setFormats] = useState(
    renderSettingData !== null ? renderSettingFormat : "H264",
  );
  const [fps, setFps] = useState(
    renderSettingData !== null ? renderSettingData.fps : renderSettingsOptions[defaultResolution].fps[0],
  );
  const [sppf, setSpps] = useState(
    renderSettingData !== null ? renderSettingData.sppf : 5,
  );
  

  useEffect(() => {
    if (!videoWidth || !videoHeight) return;
    const matched = getResolutionFromHeightAndWidth(videoHeight, videoWidth);
    if (matched) {
      setResolution(matched);
      if (renderSettingsOptions[matched]?.aspectRatio) {
        setAspectRatio(renderSettingsOptions[matched].aspectRatio);
      }
    } else {
      setResolution(`${videoWidth} x ${videoHeight}`);
    }
  }, [videoWidth, videoHeight]);

  useEffect(() => {
    if (!credits || credits.length === 0) return;

    const curatedOptions = credits.map((credit) => {
      const {
        screen_duration,
        transition_in,
        transition_in_duration,
        transition_out,
        transition_out_duration,
        delay,
      } = credit.options || {};

      return {
        screen_duration: Math.ceil((screen_duration || 0) * fps),
        transition_in: (transition_in || "").toLowerCase(),
        transition_in_duration:
          transition_in_duration && transition_in !== ""
            ? Math.ceil(transition_in_duration * fps)
            : 0,
        transition_out: (transition_out || "").toLowerCase(),
        transition_out_duration:
          transition_out_duration && transition_out !== ""
            ? Math.ceil(transition_out_duration * fps)
            : 0,
        delay: Math.ceil((delay || 0) * fps),
      };
    });

    setCardScreenOptions(curatedOptions);
  }, [credits, fps]);

  

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${createdAt?.getMonth() + 1
    }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [buyBackActive, setBuyBackActive] = useState();

  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;
    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
    const purchaseDate = currentPlan?.plan?.createdAt;
    if (purchaseDate) {
      const purchaseTime = new Date(purchaseDate);
      const buyBackTime = new Date(
        purchaseTime.getTime() + 3 * 24 * 60 * 60 * 1000,
      );
      const isBuyBackActive = buyBackTime >= new Date();

      setBuyBackActive(isBuyBackActive);
    }

    dispatch(getUserAllInformation());
  }, []);
  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);

  useEffect(() => {
    // const roleName_tr = document.querySelectorAll(".roleName_tr");
    const Cardscrollable = document.querySelectorAll(".Cardscrollable");
    const emptyLogo = document.querySelectorAll(".border-for-empty-logo");
    const bulletClas = document.querySelectorAll(".bullet");
    const RespPreviewClass = document.querySelectorAll(".RespPreviewClass");
    const aspectRatioClassStyle = document.querySelectorAll(".aspectRatioClassStyle");
    const cardContentCenter = document.querySelectorAll(".cardContentCenter");
    const CardBlockCententHide = document.querySelectorAll(".CardBlockCententHide");
    const displayTitle = document.querySelectorAll(".displayTitle");

    function handleStatusChange() {
      // if (roleName_tr) {
      //   roleName_tr?.forEach((tr) => {
      //     tr.style.display = "flex";
      //     tr.style.alignItems = "end";
      //   });
      // }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-for-empty-logo")) {
            el.classList.replace(
              "border-for-empty-logo",
              "border-none-for-empty-logo",
            );
          }
        });
      }
      if (Cardscrollable) {
        Cardscrollable?.forEach((div) => {
          div.style.height = "100vh";
        });
      }
      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "inline-block";
          span.style.backgroundColor = "transparent";
          span.style.marginTop = "0.1em";
          // span.style.width = "1em";
        });
      }
      if (RespPreviewClass) {
        RespPreviewClass?.forEach((div) => {
          div.style.zoom = "1";
        });
      }
      if (aspectRatioClassStyle) {
        aspectRatioClassStyle?.forEach((div) => {
          div.style.border = "0px solid gray";
        });
      }
      if (cardContentCenter) {
        cardContentCenter?.forEach((div) => {
          div.style.width = "100vw";
        });
      }
      if (CardBlockCententHide) {
        CardBlockCententHide?.forEach((div) => {
          div.style.overflow = "hidden";
        });
      }
      if (displayTitle) {
        displayTitle?.forEach((div) => {
          div.style.display = "none";
        });
      }
    }

    handleStatusChange();
    return function cleanup() {
      // if (roleName_tr) {
      //   roleName_tr?.forEach((tr) => {
      //     tr.style.display = "flex";
      //     tr.style.alignItems = "baseline";
      //   });
      // }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-none-for-empty-logo")) {
            el.classList.replace(
              "border-none-for-empty-logo",
              "border-for-empty-logo",
            );
          }
        });
      }
      if (Cardscrollable) {
        Cardscrollable?.forEach((div) => {
          div.style.height = "100%";
        });
      }

      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "flex";
          span.style.justifyContent = "center";
          span.style.alignItems = "center";
        });
      }
      if (RespPreviewClass) {
        RespPreviewClass?.forEach((div) => {
          div.style.zoom = ".8";
        });
      }
      if (aspectRatioClassStyle) {
        aspectRatioClassStyle?.forEach((div) => {
          div.style.border = "1px solid #373843";
        });
      }
      if (cardContentCenter) {
        cardContentCenter?.forEach((div) => {
          div.style.width = "100%";
        });
      }
      if (CardBlockCententHide) {
        CardBlockCententHide?.forEach((div) => {
          div.style.overflow = "inherit";
        });
      }
      if (displayTitle) {
        displayTitle?.forEach((div) => {
          div.style.display = "flex";
        });
      }
    };
  });

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };
  const handleResolutionChange = (val) => {
    setResolution(val);
    if (!renderSettingsOptions[val].fps.includes(fps)) {
      setFps(renderSettingsOptions[val].fps[0]);
    }
    setAspectRatio(renderSettingsOptions[val].aspectRatio);
  };

  const handleFormatChange = (val) => {
    setFormats(val);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };
  // console.log(credits);

  // function to get render time according to the png that is being formed from our side;
  const getHeight = () => {
    const totalDuration = credits
      .reduce((total, credit) => {
        const screen_duration = credit.options.screen_duration;
        const transition_in = credit.options.transition_in;
        const transition_out = credit.options.transition_out;
        const transition_in_duration =
          transition_in !== "" ? credit.options.transition_in_duration : 0;
        const transition_out_duration =
          transition_out !== "" ? credit.options.transition_out_duration : 0;
        const delay = credit.options.delay;
        return total + screen_duration + delay;
      }, 0)
      .toFixed(2);
    const min = Math.floor(totalDuration / 60);
    const sec = Math.floor(totalDuration % 60);
    setMin(min);
    setSec(sec);
  };

  // Few Block height iscaling problem
  const handleExport = async () => {
    console.log("2 After verified Render Start handleExport => ");

    setLoading(true);
    try {
      const blocks = document.querySelectorAll(".blockWrapper");
      // const FontBlocks = document.querySelectorAll(".FontSIzeScale");

      // // Store the original dimensions and font sizes before scaling
      // const originalHeights = Array.from(blocks).map((el) => el.clientHeight);
      // const originalWidths = Array.from(blocks).map((el) => el.clientWidth);
      // const originalFontSize = Array.from(FontBlocks).map((el) =>
      //   parseFloat(window.getComputedStyle(el).fontSize),
      // );
      // blocks.forEach((el, index) => {
      //   el.style.width = videoWidth + "px";
      // });

      // // Calculate the scaling factor based on the selected resolution
      // const previewBlockWidth = 800;
      // const resolutionScale = videoWidth / previewBlockWidth;

      // // Scale font size for the preview
      // FontBlocks.forEach((el, index) => {
      //   const baseFontSize = originalFontSize[index]; // Use the original font size
      //   const fontScale = resolutionScale * baseFontSize + 0.6; // Multiply by 2 to increase the size significantly

      //   FontBlocks[index].style.fontSize = fontScale + "px";
      // });

      const originalHeights = Array.from(blocks).map((el) => el.clientHeight);

      const OVERSCALE = 1.07; // fullest card fills ~7% past the frame; use 1.0 for exact fit, no clip

      // Editor frame height (~450). normalScale maps it to the video frame and
      // is the "never enlarge past normal" cap.
      const frameHeight = blocks[0]?.clientHeight || videoHeight;
      const normalScale = videoHeight / frameHeight;

      // Set EVERY card to the export width first, so content wraps exactly as it
      // will in the render. (Measuring at the narrow editor width over-counted
      // wrapping cards like the disclaimer, which shrank the whole deck and
      // pushed block 1 out of position.)
      blocks.forEach((block) => {
        block.style.width = videoWidth + "px";
      });

      // PASS 1 — measure each card at base fonts, at export width. deckScale =
      // normal size, shrunk only enough that the FULLEST card fits. One scale
      // for the whole deck keeps every card consistent.
      let deckScale = normalScale;
      blocks.forEach((block) => {
        const prevH = block.style.height;
        const prevMinH = block.style.minHeight;
        block.style.transform = "none";
        block.style.height = "auto";
        block.style.minHeight = "0";
        // const contentHeight = block.scrollHeight || frameHeight;
        block.style.height = prevH;
        block.style.minHeight = prevMinH;
        // const fit = (videoHeight * OVERSCALE) / contentHeight;
        // if (fit < deckScale) deckScale = fit;
      });

      // PASS 2 — apply deckScale to every card, then center it in the video frame.
      // Scale the FontSIzeScale root and any nested spans that still carry an
      // explicit fontSize (heading/subheading lines inherit from the root).
      const scaleFontSize = (el, scale) => {
        const baseFontSize = parseFloat(window.getComputedStyle(el).fontSize);
        if (baseFontSize) {
          el.style.fontSize = scale * baseFontSize + "px";
        }
      };

      blocks.forEach((block) => {
        block.querySelectorAll(".FontSIzeScale").forEach((fontEl) => {
          const targets = [
            fontEl,
            ...fontEl.querySelectorAll("span[style*='font-size'], span[style*='fontSize']"),
          ];
          targets.forEach((el) => scaleFontSize(el, deckScale));
        });
        // Vertical centering moved below — it must run AFTER #preview is resized,
        // when the frame is finally videoHeight.
      });
      const scrollPixelPerFrame = sppf;
      const { num: fpsNumerator, den: fpsDenominator } = fpsNumAndDen[fps];

      const focusedNode = document.querySelector(".CardfocusDiv");
      focusedNode?.classList?.remove("CardfocusDiv");

      const element = document.getElementById("preview");
      element.classList.remove("Cardscrollable");

      element.setAttribute(
        "style",
        `width: ${videoWidth}px;height:100%;`,
      );

      // Frame is now videoHeight — vertically center each card's content for real.
      // Self-correcting: measures where the content sits, shifts it to the exact
      // center. Works regardless of viewBlock; uses layout props so zoom can't
      // distort it.
      blocks.forEach((block) => {
        const contentEl = block.querySelector('[id^="block_"]');
        if (!contentEl) return;
        contentEl.style.transform = "none";
        const prevPos = block.style.position;
        block.style.position = "relative";
        const delta =
          (block.clientHeight - contentEl.offsetHeight) / 2 - contentEl.offsetTop;
        contentEl.style.transform = `translateY(${delta}px)`;
        block.style.position = prevPos;
      });

      const elementsToUpdate = document.querySelectorAll(
        ".blockWrapper .watermark, .blockWrapper .watermark_displaynone",
      );

      elementsToUpdate.forEach((element) => {
        if (isUserPaid) {
          element.classList.replace("watermark", "watermark_displaynone");
        } else {
          element.classList.replace("watermark_displaynone", "watermark");
        }
      });

      await sleep(1000);

      const projectBg = getProjectBackgroundStyle(projectSettings);
      const backgroundStyle = {
        ...projectBg,
        backgroundColor: "transparent",
      };
      blocks.forEach((block) => {
        block.style.width = `${videoWidth}px`;
        block.style.height = `${videoHeight}px`;
        block.style.minHeight = `${videoHeight}px`;
      });

      const images = [];
      for (let idx = 0; idx < blocks.length; idx++) {
        const item = blocks[idx];
        const { blob } = await captureElementAsPng(item, {
          scale: 1,
          backgroundColor: null,
          backgroundStyle,
        });
        images.push({ blob, idx });
      }

      // Save render settings to localStorage
      localStorage.setItem(
        "renderSettings",
        JSON.stringify({
          resolution: resolution,
          format: formats,
          sppf: scrollPixelPerFrame,
          fps: fps,
        }),
      );


      console.log("3 Image generation complete => ");

      const renderResult = await dispatch(
        requestRenderX3Video(images, cardScreenOptions, {
          videoHeight,
          videoWidth,
          scrollPixelPerFrame,
          fpsDenominator,
          fpsNumerator,
          format: formats === "H264" ? "outputH264" : formats,
          aspectRatio,
          isEmailSend,
        }),
      );

      console.log("6 Card renderResult Redux Data => ", renderResult);

      setRenderOpen(false);
      setIsRenderExport(true);

      if(renderResult?.success) {
        toast(
          <CustomToast title={renderResult?.message || "Card Render Failed"} content={"Card Render Failed"} />,
          customToatStyle,
        );
      }

      console.log("7 Card Render Response toast console => ");
      toast(<CustomToast title="Call" content={mesg} />, customToatStyle);

      element.removeAttribute("style");
      focusedNode?.classList?.add("CardfocusDiv");
      element?.classList?.add("Cardscrollable");

      // // Restore original styles
      blocks.forEach((el, index) => {
        el.style.height = originalHeights[index] + "px";
        el.style.minHeight = originalHeights[index] + "px";
      });

      dispatch(updatePreviewScale(1));

      if (renderResult?.success) {
        toast(<CustomToast title="" content={mesg} />, customToatStyle);
        const newRender = renderResult.renders;
        const renderId = newRender[newRender.length - 1]._id;

        const notifyObj = {
          name: "render",
          details: newRender[newRender.length - 1],
          project_id: _id,
          render_id: renderId,
          message: `Rendering Completed ${newRender[newRender.length - 1].videoFilename
            }`,
          status: 1,
          user_id: user._id,
        };
        setCurrentNotification(notifyObj);
        await dispatch(
          addNotifications({
            project_id: _id,
            render_id: renderId,
            message: `Render in progress ${newRender[newRender.length - 1].videoFilename
              }`,
            status: 1,
            user_id: user._id,
          }),
        );
        dispatch(increaseRenderCnt());

        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        toast(
          <CustomToast title="" content={"Card Render Failed"} />,
          customToatStyle,
        );
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleExportSubmit = () => {
    console.log("1 Card Render Start handleExportSubmit Verify User Paid or Not => ");
    if (!renderDone && buyBackActive) {
      dispatch(markRenderDone());
    }

    if (isUserPaid) {
      console.log("! Card Render Start handleExportSubmit => Paid User ", isUserPaid);
      handleExport();
    }

    if (!isUserPaid) {
      console.log("! CardRender Start handleExportSubmit => Not Paid User");

      navigate("/user-plans", {
        state: {
          isRender: true,
          isMoreInfo: false,
          isCard: isCard,
          projectId: projectId ?? null,
        },
      });
      return;
    }
  };

  renders = renders?.sort(
    (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
  );

  const paideRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
    (resolutionType) => {
      return { label: resolutionType, value: resolutionType };
    },
  );
  const paideRenderFormats = Object.entries(format).map(([key, value]) => ({
    label: key,
    value: value,
  }));
  const paidFramRate = renderSettingsOptions[resolution]?.fps?.map((_fps) => ({
    label: _fps,
    value: _fps,
  }));
  const expirationMessage =
    Object.keys(currentPlan).length === 0
      ? "With scrollx watermark"
      : remainingDays === 0
        ? "Plan Expired"
        : remainingDays === 1 || validityValue === 1
          ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
          : remainingDays > 1
            ? `Remaining ${remainingDays} days`
            : "";

  function addIntervalToPurchaseDate(
    planPurchaseDate,
    interval_count,
    interval_type,
  ) {
    const purchaseDate = planPurchaseDate;

    // Check if the purchase date is valid
    if (isNaN(purchaseDate)) {
      return null;
    }

    // Based on the interval_type, add to the date accordingly
    switch (interval_type) {
      case "day":
        purchaseDate.setDate(purchaseDate.getDate() + interval_count);
        break;
      case "month":
        purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
        break;
      case "year":
        purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
        break;
      default:
        throw new Error("Invalid interval type");
    }

    // Return date in YYYY-MM-DD format
    return purchaseDate;
  }

  const expirationDate =
    currentPlanDetails !== null
      ? addIntervalToPurchaseDate(
        createdAt,
        currentPlanDetails?.interval_count,
        currentPlanDetails?.interval,
      )
      : new Date();

  const expiryString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Expiration Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1
      }/${expirationDate.getFullYear()}`
      : "";
  const renewalString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Renewal Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1
      }/${expirationDate.getFullYear()}`
      : "";

  const currentDate = new Date();
  const isPlanActive = currentDate < expirationDate;

  useEffect(() => {
    getHeight();
  }, [sppf, fps, resolution]);

  return (
    <>
    <EC_Render isOpen={renderOpen} closeModal={() => setRenderOpen(false)}>
      {loading ? (
        <div className="requestLoader">
          <img className="absolute opacity-80" width="120px" height="120px" src={Scrollx_animate} />
          <p className="mt-[8rem] text-[0.9rem] text-white">Requesting Video ... </p>
        </div>
      ) : null}

      {/* <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        message="By clicking 'Render', you agree that the 3-day money-back guarantee will be void. Are you sure you want to continue?"
      /> */}

      <div className="bodyContainer" style={{ minHeight: "100vh", minHeight: "-webkit-fill-available" }}>

        <div className="particles"></div>

        <div className="layoutContainer-shell">

          <div className='header-topbar'>
            <RenderNavbar closeModal={() => setRenderOpen(false)} />
          </div>

          {/* zoom scaling applies to page content only, so the navbar stays a fixed height */}
          <main className="renderPage-Container responsiveZoomClass w-full max-w-[1388px] mx-auto px-4 md:px-8 py-8 md:py-10">

            <section className="mx-auto topSection">
              <div className=" renderSection1">
                <RenderSettings
                  renderOpen={renderOpen}
                  IsUpgradeOpen={IsUpgradeOpen}
                  
                  isCard={isCard}
                  
                  // resolution={resolution}
                  // handleResolutionChange={handleResolutionChange}
                  // aspectRatio={aspectRatio}

                  formats={formats}
                  handleFormatChange={handleFormatChange}
                    
                  fps={fps}
                  setFps={setFps}
                  
                  sppf={sppf}
                  setSpps={setSpps}
                  
                  min={min}                  
                  sec={sec}

                  isEmailSend={isEmailSend}
                  setIsEmailSend={setIsEmailSend}

                  handleCardRenderExport={handleExportSubmit}
                  isLoading={isLoading}
                  loading={loading}
                  
                  renderCnt={3}
                    
                  isUserPaid={isUserPaid}
                  isPlanActive={isPlanActive}
                    
                  paideRenderSettingsOptions={paideRenderSettingsOptions} 
                  freeRenderFormats={freeRenderFormats}
                  paideRenderFormats={paideRenderFormats}                    
                  freeFramRate={freeFramRate}
                  paidFramRate={paidFramRate}
                />
              </div>
            </section>

            <section className='mx-auto bottomSection'>
              <div className=" renderSection2">
                <RendersTable />
              </div>
            </section>

          </main>

        </div>
      </div>
      </EC_Render>
    </>
  )
}

export default CardRender;